import constants from '../constants';
import globals from '../../globals';

const { WEBSITE_ANIMATION_DATA_ATTRIBUTE } = constants;

const getEffectsConfig = () => {
  const headerCodeGlobal = globals.operations.extractGlobalContent('header-code');
  const footerCodeGlobal = globals.operations.extractGlobalContent('footer-code');
  if (!headerCodeGlobal && !footerCodeGlobal) return {};

  const websiteAnimation = Boolean(
    headerCodeGlobal.querySelector(`[${WEBSITE_ANIMATION_DATA_ATTRIBUTE}]`) &&
      footerCodeGlobal.querySelector(`[${WEBSITE_ANIMATION_DATA_ATTRIBUTE}]`)
  );

  return {
    websiteAnimation,
  };
};

export default getEffectsConfig;
